import script from "./TemplateManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateManager.vue?vue&type=script&setup=true&lang=js"

import "./TemplateManager.vue?vue&type=style&index=0&id=1fa696b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa696b4"]])

export default __exports__